import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Progress, Typography} from "@material-tailwind/react";
import React, {useContext} from "react";
import {ServiceFollowUpContext} from "../../context/service_follow_up";
import dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function ServiceFollowUpForm() {

  const {
    serviceFollowUp,
    setOpen,
    open,
    roleId,
  } = useContext(ServiceFollowUpContext);

  const handleOpen = () => setOpen(!open);

  if (serviceFollowUp) {
    return (
      <>
        <Dialog open={open} handler={handleOpen}
                animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>پیگیری خدمات</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

            {serviceFollowUp.progress > 0 &&
              <Progress value={Math.ceil(serviceFollowUp.progress)} size="lg" label="پیشرفت"
                        className="text-right"/>
            }

            <div className="grid grid-cols-1 gap-4">

              {roleId !== 3 &&
                <div
                  className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
                >
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray">
                      {`${dict("user")}:`}
                    </Typography>
                  </div>
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray" variant="h6">
                      {`${serviceFollowUp.person_name}`}
                    </Typography>
                  </div>
                </div>
              }

              {roleId !== 3 && roleId !== 2 &&
                <div
                  className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
                >
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray">
                      {`${dict("user_phone")}:`}
                    </Typography>
                  </div>
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray" variant="h6">
                      {`${persianNumberFormat(serviceFollowUp.person_phone)}`}
                    </Typography>
                  </div>
                </div>
              }

              {roleId !== 2 &&
                <div
                  className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
                >
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray">
                      {`${dict("agent")}:`}
                    </Typography>
                  </div>
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray" variant="h6">
                      {`${serviceFollowUp.agent_name}`}
                    </Typography>
                  </div>
                </div>
              }

              {roleId !== 3 && roleId !== 2 &&
                <div
                  className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
                >
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray">
                      {`${dict("agent_phone")}:`}
                    </Typography>
                  </div>
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray" variant="h6">
                      {`${persianNumberFormat(serviceFollowUp.agent_phone)}`}
                    </Typography>
                  </div>
                </div>
              }

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("branch_title")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${serviceFollowUp.branch_name}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("step")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(serviceFollowUp.step)}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("title")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${serviceFollowUp.step_title}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("description")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${serviceFollowUp.step_description}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("payment_date")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(serviceFollowUp.created_at.split(" ")[0])}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("deadline_date")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(serviceFollowUp.dead_line.split(" ")[0])}`}
                  </Typography>
                </div>
              </div>

              {serviceFollowUp.days_to_dead_line < 0 &&
                <div
                  className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
                >
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray">
                      {`${dict("delay")}:`}
                    </Typography>
                  </div>
                  <div className="grid grid-col min-w-fit">
                    <Typography color="blue-gray" variant="h6">
                      {`${persianNumberFormat(Math.abs(serviceFollowUp.days_to_dead_line))} روز`}
                    </Typography>
                  </div>
                </div>
              }

            </div>

          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </>
    );
  }
}